import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import AppButton from "../../Components/MerchantButton";
import "./UnifiedFormStyles.css";

function ChargerDelivery({ navigation, primaryDetails, setPrimaryDetails }) {
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setPrimaryDetails((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: false }));
  };

  const validate = () => {
    const newErrors = {
      charger_delivery: !primaryDetails.charger_delivery,
    };

    setErrors(newErrors);
    const hasErrors = Object.values(newErrors).some(Boolean);

    if (hasErrors) {
      return false;
    }
    return true;
  };

  const isFormValid = () => {
    return !!primaryDetails.charger_delivery;
  };
  const handleSubmit = () => {
    if (validate()) {
      if (primaryDetails.charger_delivery === 'Yes') {
        navigation.go('charger-delivery-yes');
      } else {
        if (primaryDetails.maya_solution === 'Terminal') {
          // navigation.go('qrph-knowledge');
          navigation.go('merchandising');
        } else {
          navigation.go('maya-sqr-solution-details');
        }
      }
    }
  };

  const handleBack = () => {
    navigation.previous();
  };



  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">CHARGER DELIVERY</h4>
              <p className="form-desc">Please fill in all required details below</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                   <Form>
                {/* Charger delivery */}
                  <Form.Label className="form-label">
                    Charger delivery <span className="form-required">*</span>
                  </Form.Label>
                  <div className="form-radio-group">
                    <div className={`form-radio-item${primaryDetails.charger_delivery === 'Yes' ? " selected" : ""}`}>
                      <div className="form-radio-flex">
                        <Form.Check
                          type="radio"
                          name="charger_delivery"
                          value="Yes"
                          label="Yes"
                          onChange={handleChange}
                          checked={primaryDetails.charger_delivery === 'Yes'}
                          className="form-radio"
                        />
                      </div>
                    </div>
                    <div className={`form-radio-item${primaryDetails.charger_delivery === 'No' ? " selected" : ""}`}>
                      <div className="form-radio-flex">
                        <Form.Check
                          type="radio"
                          name="charger_delivery"
                          value="No"
                          label="No"
                          onChange={handleChange}
                          checked={primaryDetails.charger_delivery === 'No'}
                          className="form-radio"
                        />
                      </div>
                    </div>
                  </div>
                  {errors.charger_delivery && (
                    <div className="form-error">
                      Required
                    </div>
                  )}

                <div className="form-nav-btns">
                  <AppButton
                    onClick={handleBack}
                    variant="back"
                    className="form-btn variant-secondary"
                  >
                    ← Back
                  </AppButton>
                  <AppButton
                    onClick={handleSubmit}
                    variant="next"
                    className="form-btn variant-primary"
                    disabled={!isFormValid()}
                  >
                  Next →
                  </AppButton>
                </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ChargerDelivery;
